import { hasWindow } from '@/utils/dom';
import { useRef } from 'react';

export function useElementTopPosition<T extends HTMLElement>(): [
	React.RefObject<T | null>,
	{ absoluteTop: number },
] {
	const ref = useRef<T>(null);

	const rect = ref.current?.getBoundingClientRect() ?? { top: 0 };

	const scrollY = hasWindow() ? window.scrollY : 0;

	const absoluteTop = rect.top + scrollY;

	return [ref, { absoluteTop }];
}
